import {
  CONTENT_ID_ALLOWLIST_LOADED,
  CONTENT_ID_ALLOWLIST_CLEAR,
} from '../../../actions/actionTypes';

const initialState = {
  allowlist: null,
};

const contentIdAllowlist = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_ID_ALLOWLIST_LOADED:
      return {
        ...state,
        allowlist: action.payload.allowlist,
      };

    case CONTENT_ID_ALLOWLIST_CLEAR:
      return {
        ...state,
        allowlist: null,
      };

    default:
      return state;
  }
};

export default contentIdAllowlist;

